import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Slider, Stack, TextField, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';
import { v4 as uuid } from 'uuid'
import _ from 'lodash';
import * as yup from 'yup'

export const ResourcesModalHandler = (props: IResourceItemHandlerProps) => {
    const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');

    const {
        onClose,
        onSubmit,
        open,
        type,
        payload
    } = props;
    const [label, setLabel] = useState<string>('');
    const [urlToDownload, setUrlToDownload] = useState<string>('');

    useEffect(() => {
        if (payload === undefined) {
            setLabel('');
            setUrlToDownload('');
        } else {
            setLabel(payload.label);
            setUrlToDownload(payload.urlToDownload);
        }
    }, [payload, open]);

    const urlIsCorrect = yup.string().url().isValidSync(urlToDownload.trim());

    const isDisabled =
        label === '' || urlToDownload === '' || urlIsCorrect === false;

    const handleOnSubmit = () => {
        if (isDisabled) return;

        const id = payload === undefined ? uuid() : payload.id;

        onSubmit({
            id: id,
            label: label.trim(),
            urlToDownload: urlToDownload.trim()
        });
        onClose();
    }

    return (
        <Dialog
            maxWidth={maxWidth}
            fullWidth={true}
            open={open}
            onClose={onClose}
        >
            {type === 'EDIT' && <DialogTitle>Actualizar recurso</DialogTitle>}
            {type === 'NEW' && <DialogTitle>Agregar recurso</DialogTitle>}
            <DialogContent dividers>
                <Stack spacing={5}>
                <Stack spacing={1}>
                        <Typography variant="h6">
                            Nombre
                        </Typography>
                        <Typography variant="subtitle1">
                            Define el nombre del recurso
                        </Typography>
                        <TextField
                            fullWidth
                            value={label}
                            onChange={(event) => {
                                setLabel(event.target.value);
                            }}
                            label="Nombre"
                            variant="outlined"
                        />
                    </Stack>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            URL de descarga
                        </Typography>
                        <Typography variant="subtitle1">
                            Define el de descarga del recurso
                        </Typography>
                        <TextField
                            error={urlIsCorrect === false}
                            helperText={urlIsCorrect ? undefined : 'El URL es incorrecto'}
                            fullWidth
                            value={urlToDownload}
                            onChange={(event) => {
                                setUrlToDownload(event.target.value);
                            }}
                            label="URL"
                            variant="outlined"
                        />
                    </Stack>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Cancelar</Button>
                    {type === 'EDIT' &&
                        <Button
                            onClick={handleOnSubmit}
                            disabled={isDisabled}>
                            Actualizar
                        </Button>}
                    {type === 'NEW' &&
                        <Button
                            onClick={handleOnSubmit}
                            disabled={isDisabled}>
                            Agregar
                        </Button>}
                </Stack>
            </DialogActions>
        </Dialog>
    );
}
